<template>
	<el-drawer v-model="drawerVisible" append-to-body :destroy-on-close="true" size="600px" :title="title">
		<el-form ref="formRef" :rules="rules" :model="formData" label-width="160px" label-suffix=" :">
			<el-form-item label="当前密码" prop="oldPwd">
				<el-input v-model="formData.oldPwd" type="password" autofocus placeholder="请输入6-20位字母或数字" clearable></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="newPwd">
				<el-input v-model="formData.newPwd" type="password" placeholder="新密码和当前密码不能相同" clearable></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="confirmPwd">
				<el-input v-model="formData.confirmPwd" type="password" placeholder="确认密码和新密码保持一致" clearable></el-input>
			</el-form-item>
		</el-form>
		<template #footer>
			<el-button @click="drawerVisible = false">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-drawer>
</template>
<script lang="ts" setup>
import { updateLoginUserPwd } from '@/api/modules/systemManage/user'
import { RouterEnum } from '@/enums/routerEnum'
import { useAppStore } from '@/store/app'
import { getValidator, passwordValidator } from '@/utils/validate'
import type { FormInstance } from 'element-plus'
const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', modelValue: boolean): void }>()
const drawerVisible = useVModel(props, 'modelValue', emit)
const title = ref('修改密码')

const formData = ref({
	oldPwd: '',
	newPwd: '',
	confirmPwd: '',
})

const rules = reactive({
	oldPwd: [
		{ required: true, message: '请填写当前密码', trigger: 'blur' },
		{ validator: passwordValidator, trigger: 'blur' },
	],
	newPwd: [
		{ required: true, message: '请填写新密码', trigger: 'blur' },
		{ validator: passwordValidator, trigger: 'blur' },
		{
			validator: getValidator(value => formData.value.oldPwd !== value, '新密码和当前密码不能相同'),
			trigger: 'blur',
		},
	],
	confirmPwd: [
		{ required: true, message: '请填写确认密码', trigger: 'blur' },
		{
			validator: getValidator(value => formData.value.newPwd === value, '确认密码和新密码保持一致'),
			trigger: 'blur',
		},
	],
})

//提交
const formRef = ref<FormInstance>()
const router = useRouter()
const handleSubmit = async () => {
	await formRef.value?.validate()
	await updateLoginUserPwd(formData.value)
	await useAppStore().logout()
	ElMessage.success('修改成功，请重新登录')
	router.push(RouterEnum.LOGIN_PAGE_PATH)
}
</script>
